import pdv from '@giro-pdv/modules/pdv/store';

const rootSubscribe = (store) => () => {
  pdv.subscriber.subscribe(store);
};

export default rootSubscribe;
